import { render } from "./EditSeatModalComponent.vue?vue&type=template&id=230a0c71&scoped=true"
import script from "./EditSeatModalComponent.vue?vue&type=script&lang=js"
export * from "./EditSeatModalComponent.vue?vue&type=script&lang=js"

import "./EditSeatModalComponent.vue?vue&type=style&index=0&id=230a0c71&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230a0c71"]])

export default __exports__